import React from "react";
import { useTranslation } from "react-i18next";
import { Rate, Divider } from "antd";
import { useObserver } from "mobx-react-lite";
import { useStores } from "@/store";

function padRight(str) {
  return Number(str).toFixed(1);
}

/**评分 */
export const RestaurantRate = ({ restaurant, showPrice, noRecommends }) => {
  const { t } = useTranslation();
  const { restaurantStore } = useStores();
  const { recommends_count, reviews_ratings, avg_price } = restaurant;
  const { ratings_avg, service_avg, cuisine_avg, atmosphere_avg } =
    reviews_ratings || {};
  return useObserver(() => {
    const { currency } = restaurantStore;
    return (
      <div className="restaurant-rate">
        <div className="restaurant-rate--title">
          <span className="inline-flex">
            <Rate count={5} value={ratings_avg / 2} disabled />
            <span className="restaurant-ratings">{padRight(ratings_avg)}</span>
          </span>
          <Divider type="vertical" hidden={!showPrice} />
          <span className="restaurant-price" hidden={!showPrice}>
            {t("WEB.avg price", { price: currency + avg_price })}
          </span>
        </div>
        <div className="restaurant-rate--desc">
          <span>
            {t("WEB.Food")}: {padRight(cuisine_avg)}
          </span>
          <span>
            {t("WEB.Service")}: {padRight(service_avg)}
          </span>
          <span>
            {t("WEB.Decoration")}: {padRight(atmosphere_avg)}
          </span>
        </div>
        <div>
          <span className="recommends" hidden={noRecommends || recommends_count < 1}>
            {t("WEB.Recommended", { count: recommends_count })}
          </span>
        </div>
      </div>
    );
  });
};
